import React, {Component} from 'react';
import {withTranslation} from "react-i18next";

class PageNotFound extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <section>
                <div className="container text-primary-dark text-center">
                    <div className="row my-5 justify-content-center">
                        <div className="col-8 col-sm-4 text-center">
                            <img src="/img/inbank/explore.svg"
                                 alt="Puslapis nerastas"
                                 className="img-fluid text-white"/>
                        </div>
                    </div>
                    <div className="row mb-5 justify-content-center">
                        <div className="col-12 col-sm-4">
                            <h1 className="h4">Ieškojote kito turinio?</h1>
                            <p>
                                Deja, tokio puslapio nėra. Užsukite į&nbsp;&nbsp;
                                <a href="http://inbank.lt">www.inbank.lt</a>.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default withTranslation()(PageNotFound);
